import { LitElement, html, css, TemplateResult } from 'lit';
import {property, customElement} from 'lit/decorators.js';
@customElement('voy-map-route-tooltip')
export class VoyMapRouteTooltip extends LitElement {
    @property({type: Boolean}) visible: boolean = false; 
    @property({attribute: false}) text?: string | HTMLElement;
    
    static get styles() {
        return [ 
            css`
                .tooltip {
                    background: var(--neutrals-grey-02, gray);
                    display: none;
                    color: white;
                    font-family: MaerskText;
                    font-size: 12px;
                }
                .tooltip[visible] {
                    display: block;
                    padding: 16px;
                    border-radius: 5px;
                    position: relative;
                    bottom: 12px;
                    color: white;
                    font-weight: bold;
                    font-size: 12px;
                    line-height: 16px;
                    font-family: MaerskText;           
                }
                p {
                    margin: 0;
                    padding:0;
                }
                .tooltip:after{
                    top: 100%;
                    border: solid transparent;
                    content: " ";
                    height: 0;
                    width: 0;
                    position: absolute;
                }
                .tooltip:after {
                    border-top-color: var(--neutrals-grey-02, gray);
                    border-width: 10px;
                    left: calc(50% - 10px);
                }
                .waypoint-content{
                    min-width: 300px;
                }
                .label{
                    padding-bottom: 10px;
                }
                .text-small{
                    font-weight: normal;
                    padding-bottom: 5px;
                }
                .flex-container{
                    display:flex;
                    flex-direction: row;
                }
                .flex-child{
                    width: 50%;
                }
            `
        ];
    }

    render() {
        return html`<div class="tooltip" ?visible=${this.visible && this.text}>
            ${this.text}
        </div>`
    }
};
